
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/instructors",
      function () {
        return require("private-next-pages/instructors.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/instructors"])
      });
    }
  